import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { AuthenticationService } from "./authentification/services/authentication.service";
import { ClientService } from "./client.service";
import { switchMap } from "rxjs/operators";

import { Client } from "../Models/client";
import { StorageService } from "./storage.service";

@Injectable({ providedIn: "root" })
export class AccountService {
  public accountSubject: BehaviorSubject<Client | null>;
  //false until the first current client request is done (success or error)
  private readonly _isResolvedSubject = new BehaviorSubject<boolean>(false);
  public readonly isResolved$ = this._isResolvedSubject.asObservable();
  private dateStartToken?: string | null;

  constructor(private storage: StorageService, private clientService: ClientService) {
    this.accountSubject = new BehaviorSubject<Client | null>(null);

    this.refreshAccount();

    /* this.authService.currentTokenSubject.pipe(

      switchMap(token => {
        const dateNow = new Date();
        this.dateStartToken = this.storage.getItem('dateStartToken');
        let difference = dateNow.getTime() - parseInt(this.dateStartToken ?? '');// in ms
        let differenceOauth2  = dateNow.getTime() -parseInt(this.storage.getItem('dateStartTokenOauth2') ?? '');// in ms
          if (token && (difference < 86400000||differenceOauth2<86400000)) { //86400000 (expiration Token) a day in ms
          return this.clientService.getCurrent();
        } else {
          this.storage.removeItem('dateStartToken');
          return of(null);

        }
      })
    ).subscribe(
      response => {
        if (response) {
          this.accountSubject.next(response.body!);
        } else {
          this.accountSubject.next(null);
        }
      }
    );*/
  }

  /**
   * @description update the accountSubject with a given value (without calling current API)
   * @param {Client} client
   */
  public update(client: Client | null) {
    this.accountSubject.next(client);
  }

  /**
   * @description get the current client and update the accountSubject with the response
   */
  refreshAccount() {
    this.clientService.getCurrent().subscribe({
      next: (response) => {
        this.accountSubject.next(response || null);
        this._isResolvedSubject.next(true);
      },
      error: () => {
        this.accountSubject.next(null);
        this._isResolvedSubject.next(true);
      },
    });
  }
}
